import Icon from '@icon/Icon';

const MinusIcon = (props) => {
  const { color, ...rest } = props;
  return (
    <Icon {...rest} viewBox="0 0 24 24">
      <path
        d="M7.5 12L17.5 12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

export default MinusIcon;
